import React, { useState, useEffect } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export default function DialogNuevo(props) {

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                open={props.open}
                onClose={props.handleClose}
                sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <DialogTitle
                    sx={{
                        background: "linear-gradient(135deg, #164e63 0%, #0c3a47 100%)",
                        color: "#fff",
                        py: 2,
                        px: 3,
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    {props.icono}
                    <Box>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 700, color: "#fff", lineHeight: 1.3 }}
                        >
                            {props.titulo}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
                        >
                            {props.subtitulo}
                        </Typography>
                    </Box>

                    <IconButton
                        onClick={props.handleClose}
                        sx={{
                            color: "#fff",
                            ml: "auto",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.15)",
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        bgcolor: "#f5f5f5",
                        display: "flex",
                        flexDirection: "column",
                        gap: 0,
                        p: 0,
                    }}
                >
                    {props.children}
                </DialogContent>
            </Dialog>
        </>
    )


}
